import { Form } from 'react-final-form'

import { SafetyCaseHazardForm as SafetyCaseHazardFormComponent } from '../../../components'

const SafetyCaseHazardForm = (props: any) => {
  const { onSubmit, initialValues, formName, additionalOptions, baseStatus, setForm, onChange, disabled, isViewMode } =
    props

  return (
    <Form
      onSubmit={onSubmit}
      initialValues={initialValues}
      component={SafetyCaseHazardFormComponent}
      formName={formName}
      baseStatus={baseStatus}
      additionalOptions={additionalOptions}
      setForm={setForm}
      onChange={onChange}
      disabled={disabled}
      isViewMode={isViewMode}
      keepDirtyOnReinitialize
    />
  )
}

export default SafetyCaseHazardForm
